/* eslint-disable no-await-in-loop */
import axios from 'axios';
import { Product } from '@pointOfSale/models';
import * as MutationTypes from './mutationsTypes';

export const getNextPageProducts = async (commit, nextProductsUrl, cancelToken) => {
  let nextPageUrl = nextProductsUrl;
  while (nextPageUrl) {
    try {
      const response = await axios.get(nextPageUrl, { removeTrailingSlash: true, cancelToken });
      const { count, results } = response.data;
      const productList = Product.toInstanceList(results);
      commit(MutationTypes.PRODUCT_SEARCH_LIST_UPDATE, { productList, count });
      nextPageUrl = response.data.next;
    } catch (error) {
      nextPageUrl = null;
      if (!axios.isCancel(error)) throw error;
    }
  }
};
